/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(
            require('underscore'),
            require('./models/fp_model'),
        );
    } else if (typeof define === 'function' && define.amd) {
        define(['underscore', './models/fp_model'], function (_, fpModel) {
            return factory(_, fpModel);
        });
    }
})(this, function (_, FpModel) {
    return {
        create: function (options) {
            var fpModel = new FpModel({ fpid: options.data.fpid });

            fpModel.save();

            return fpModel;
        },
    };
});
